const LAYOUTS = Object.freeze({
  FULL_WIDTH: 'full_width',
  LEFT_HALF: 'left_half',
  RIGHT_HALF: 'right_half',
  LEFT_TWO_THIRD: 'left_two_third',
  RIGHT_TWO_THIRD: 'right_two_third',
});

export default LAYOUTS;
